module.exports = __webpack_public_path__ + "img/order.f9c65708.svg";